import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';
import { useState } from 'react';
import { cn } from '@/lib/utils';

export const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  const currentLanguage = i18n.language === 'de' ? 'DE' : 'EN';

  return (
    <div className="relative">
      {/* Language Options - erscheint unter dem Button */}
      <div
        className={cn(
          "absolute top-full right-0 mt-2 bg-card border rounded-lg shadow-lg overflow-hidden transition-all duration-200 z-[200]",
          isOpen ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"
        )}
      >
        <button
          onClick={() => changeLanguage('de')}
          className={cn(
            "w-full px-4 py-2.5 text-left hover:bg-accent transition-colors flex items-center gap-2 min-w-[120px]",
            i18n.language === 'de' && "bg-accent/50"
          )}
        >
          <span className="text-lg">🇩🇪</span>
          <span className="font-medium">Deutsch</span>
        </button>
        <button
          onClick={() => changeLanguage('en')}
          className={cn(
            "w-full px-4 py-2.5 text-left hover:bg-accent transition-colors flex items-center gap-2",
            i18n.language === 'en' && "bg-accent/50"
          )}
        >
          <span className="text-lg">🇬🇧</span>
          <span className="font-medium">English</span>
        </button>
      </div>

      {/* Trigger Button */}
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setIsOpen(!isOpen)}
        className="h-8 w-8 text-primary-foreground hover:bg-primary-foreground/20"
      >
        <Globe className="h-4 w-4" />
      </Button>
    </div>
  );
};
